import * as Yup from 'yup';
// import PropTypes from 'prop-types';
import { useCallback, useEffect, useState } from 'react';
import { useSnackbar } from 'notistack';
import { useLocation, useNavigate } from 'react-router-dom';
import { Form, FormikProvider, useFormik } from 'formik';
// material
import { LoadingButton, MobileDatePicker } from '@material-ui/lab';
import { useTheme } from '@material-ui/core/styles';
import { experimentalStyled as styled } from '@material-ui/core/styles';
import { InputLabel } from '@mui/material';

import {
  Box,
  Card,
  Grid,
  Stack,
  Switch,
  TextField,
  Typography,
  Link,
  FormHelperText,
  FormControlLabel,
  Button,
  Container,
  Autocomplete,
  Chip,
  CardHeader
} from '@material-ui/core';

// utils
import { fData } from '../../../utils/formatNumber';
import fakeRequest from '../../../utils/fakeRequest';
// routes
import { PATH_DASHBOARD } from '../../../routes/paths';
import HeaderBreadcrumbs from 'src/components/HeaderBreadcrumbs.js';
import Page from 'src/components/Page.js';
//
import Label from '../../Label';
import { UploadAvatar, UploadSingleFile } from '../../upload';
import { Link as RouterLink } from 'react-router-dom';
import countries from '../user/countries';
import moment from 'moment';
import axios from 'axios';
import { REST_API_END_POINT, UNITS } from '../../../constants/Defaultvalues';

export default function AddTimeAndMaterialProduct({timeMaterial}) {
  const location = useLocation()
  const in_house=location.state?.inhouse
  const timeAndMaterialTab=location.state?.timeAndMaterial || timeMaterial
  const Edit=location.state?.edit

  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const theme = useTheme()
//   const [selectedFile, setSelectedFile] = useState([]);
//   const [category, setCategory] = useState([]);
//   const [subCategory, setSubCategory] = useState([]);
//   const [tags, setTags] = useState([])
//   const [inputValue, setInputValue] = useState('')
//   const [workflows, setWorkflows] = useState([])
//   const [recipe, setRecipe] = useState([])
//   const [inHouse, setInHouse] = useState(in_house)
const [data,setData] = useState([])

  const currentDate = moment().format('MM-DD-YYYY');
  // const isEdit =false
  const NewProductSchema = Yup.object().shape({
    name: Yup.string().required('Name is required'),
    description: Yup.string().required('Description is required'),
    sellingPrice:Yup.number().required('Selling Price is required').min(0, 'Selling Price must be greater than 0 number'),
  });
  //

  const LabelStyle = styled(Typography)(({ theme }) => ({
    ...theme.typography.subtitle2,
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(1)
  }));
  //

  useEffect(()=>{
    if (Edit) { 
        fetchProduct();
      }

  },[Edit])

  const fetchProduct = async () => {
    try {
      const response = await axios.post(`${REST_API_END_POINT}product/get-product-by-id?id=${Edit}`);
      if(response.data.status===1) {
        setData(response.data.result[0])
          console.log('editdataaaaaaaaaaaaaaaa', response.data.result);
      }
    } catch (error) {
      console.error('Error fetching product:', error);
    }
  };



  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      name:data?data.name : '',
      description:data?data.description : '',
      sellingPrice: data?data.price : '',
    },
    validationSchema: NewProductSchema,
    onSubmit: async (values, { setSubmitting, resetForm, setErrors, setFieldError }) => {
      try {
        const user = localStorage.getItem('user')
        const userData = JSON.parse(user)
        values.id = userData.user_id
          const formData = new FormData();
          formData.append("name", values.name);
          formData.append("description", values.description);
          formData.append("sellingPrice", values.sellingPrice)
          formData.append("added_by", values.id);
          formData.append("timeandmaterial", timeAndMaterialTab);
          try {
            const response = await axios.post(`${REST_API_END_POINT}product/${Edit?`update-product?id=`+Edit:'add-product'}`, formData, {
              headers: { 'Content-Type': 'multipart/form-data' }
            });
            // console.log("response.data : ", response.data);
            if (response.data.status === 1) {
              enqueueSnackbar(`Catalog ${values.name} added successfully`, { variant: 'success' });
            }
            else if (response.data.status === 2) {
              enqueueSnackbar('The Catalog already exist!', { variant: 'error' });
            }
            else if (response.data.status === 0) {
              enqueueSnackbar('Failed to add the Catalog', { variant: 'error' });
            }
            else if (response.data.status === 406) {
              enqueueSnackbar(response.data.status, { variant: 'error' });
            }
            else if (response.data.status === 500) {
              enqueueSnackbar('Server error', { variant: 'error' });
            }
          } catch (error) {
            enqueueSnackbar('Error in adding Catalog', { variant: 'error' });
            console.error("Axios request failed:", error.message);
            if (error.response) {
              console.error("Response data:", error.response.data);
              console.error("Response status:", error.response.status);
              console.error("Response headers:", error.response.headers);
            } else if (error.request) {
              console.error("No response received. Request details:", error.request);
            } else {
              console.error("Error setting up the request:", error.message);
            }
          }
          resetForm();
          setSubmitting(false);
          navigate(PATH_DASHBOARD.products.main,{state:{
           in_house:timeMaterial?'time_and_material':'in_house'
          }});
        
      } catch (error) {
        console.error("Error : ", error);
        setSubmitting(false);
        setErrors(error);
      }
    }
  });

  const { errors, values, touched, handleSubmit, isSubmitting, setFieldValue, getFieldProps } = formik;


  const handleCancel=()=>{
    navigate(PATH_DASHBOARD.products.main,{state:{
       in_house:timeMaterial?'time_and_material':'in_house'
    }});
  }
  return (
    <Page title="Add Catalog | LOLDAO SUPPORT">
      <Container>
        <FormikProvider value={formik}>
          <Form noValidate autoComplete="off" onSubmit={handleSubmit}>

            <Grid container spacing={3} justifyContent="center" alignItems="center">
               
        
              <Grid item xs={12} md={10}>
              <Typography variant='h6' gutterBottom>
              Time & Material
                </Typography>
                <Card sx={{ p: 10, margin: 'auto', height: 'fit-content' }}>
                 
                  <Stack spacing={3}>
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                      <TextField
                        required
                        fullWidth
                        label="Name"
                        type="text"
                        InputLabelProps={{ shrink: true }}
                        {...getFieldProps('name')}
                        // value={values.name}
                        // onChange={(name)=>setFieldValue('name',name)}
                        error={Boolean(touched.name && errors.name)}
                        helperText={touched.name && errors.name}
                      />
                      <TextField
                        required
                        fullWidth
                        label="Description"
                        type="text"
                        InputLabelProps={{ shrink: true }}
                        {...getFieldProps('description')}
                        // value={values.description}
                        // onChange={(description)=>setFieldValue("description",description)}
                        error={Boolean(touched.description && errors.description)}
                        helperText={touched.description && errors.description}
                      />
                    </Stack>

                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                      <TextField
                        required
                        fullWidth
                        label="Selling Price"
                        type="number"
                        InputLabelProps={{ shrink: true }}
                        {...getFieldProps('sellingPrice')}
                        error={Boolean(touched.sellingPrice && errors.sellingPrice)}
                        helperText={touched.sellingPrice && errors.sellingPrice}
                      />
                    
                    </Stack>


                    <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end' }}>
                      <LoadingButton type="submit" variant="contained" loading={isSubmitting}>
                        {Edit? 'Update' : 'Add'} Catalog
                      </LoadingButton>
                      <Button variant="outlined" type="submit" onClick={handleCancel} sx={{ marginLeft: '10px' }}>
                        Cancel
                      </Button>
                    </Box>
                  </Stack>

                  
                </Card>
              </Grid>
            </Grid>
          </Form>
        </FormikProvider>
      </Container>
    </Page>
  );
}